import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '../store'
import { clientReport } from '../client'
import { PDF_TABLE, PAGE_ACTION } from '../client/constant'
import { getOpenFrom, getPageByRouter } from '@/utils'
Vue.use(Router)
const router = new Router({
  routes,
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  // 获取打开来源
  const openFrom = getOpenFrom()
  // 获取要跳转的路由(路由名字可能为空,所以以路径为准)
  const router = to.path.split('/').pop()
  const page = getPageByRouter(router)

  // REPORT 进入功能页触发埋点上报
  clientReport(PDF_TABLE, {
    source: openFrom,
    page_show: page,
    click: PAGE_ACTION.DEFAULT
  })
  next()
})

router.afterEach(to => {
  window.scrollTo(0, 0)
})

export default router
